// extracted by mini-css-extract-plugin
export default {"textarea":"TextArea_textarea__n98MX","label":"TextArea_label__S1U69"};